module.exports = __webpack_public_path__ + "img/lkz_ico_48.b75e3ce0.svg";